import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import SettingsAccountVerificationProvider from "./SettingsAccountVerificationProvider";
import ShowToast from "../../../../widget/common/ui/Toast";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { AlertMesage } from "../../../../widget/common/ui/Alerts";
import { appRoutes } from "../../../../routes/routes";
import SessionStorage from "../../../../service/storage/SessionStorage";
import StorageKeys from "../../../../const/StorageKeys";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import Loader from "../../../../widget/common/ui/Loader";
import { EmailChangeResult } from "../../../../model/settings/SettingsAccountVerificationChangeEmailModel";
import { useDispatch } from "react-redux";
import { resetCountDown } from "../../../../libraries/state_reducers/widget/CountdownReducer";

type SettingsAccountVerificationTypes = {
  sendPin: (code: string) => void;
  resendVerification: () => void;
  pincodeLength: number;
  pincode: string;
  countDownStatus: boolean;
  updateCountDownStatus: (status: boolean) => void;
};

const SettingsAccountVerificationContext = createContext<
  SettingsAccountVerificationTypes | undefined
>(undefined);

export const SettingsAccountVerificationContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const dispatch = useDispatch();

  const pincodeLength: number = 4;
  const [pincode, setPincode] = useState<string>("");
  const [countDownStatus, setCountDownStatus] = useState<boolean>(true);

  
  const checkVericationSession = () => {
    const verificationSession = SessionStorage.getValue(
      StorageKeys.settings_verification_detail
    );

    if (UtilityHelper.isNotEmpty(verificationSession)) {
      const verificationSessionVal: EmailChangeResult =
        JSON.parse(verificationSession);

      setPincode(verificationSessionVal?.verif_code!);
    }
  };

  const updateCountDownStatus = (status: boolean) => {
    setCountDownStatus(status);
  };

  const sendPin = async (code: string) => {
    if (code.length === pincodeLength && countDownStatus) {
      console.log(`code: ${code}`);
      console.log(`pincode: ${pincode}`);
      if (code === pincode) {
        Loader.modal();
        const statusResponse: boolean =
          await SettingsAccountVerificationProvider.submitPinAPI({
            code: code,
          });
        Loader.modal(false);

        if (statusResponse) {
          SessionStorage.deleteValue(
            StorageKeys.settings_verification_change_email_value
          );
          SessionStorage.deleteValue(
            StorageKeys.settings_verification_change_phone_value
          );
          SessionStorage.deleteValue(StorageKeys.settings_verification_detail);

          const verificationTypeSession: string = SessionStorage.getValue(
            StorageKeys.settings_verification_type
          );

          if (verificationTypeSession === "phone") {
            alertMessageResponse("phone_updated_successfully");
          } else {
            alertMessageResponse("email_updated_successfully");
          }
        } else {
          ShowToast.warning(AppTranslation.text("something_went_wrong"));
        }
      } else {
        ShowToast.warning(AppTranslation.text("otp_code_invalid"));
      }
    }
  };

  const resendVerification = async () => {
    const verificationType: string = SessionStorage.getValue(
      StorageKeys.settings_verification_type
    );

    Loader.modal();
    const emailChangeResult: EmailChangeResult | null =
      await SettingsAccountVerificationProvider.resendVerificationAPI({
        typeName: verificationType as "email" | "phone",
      });
    Loader.modal(false);

    if (emailChangeResult != null) {
      dispatch(resetCountDown());
      setPincode(emailChangeResult?.verif_code!);
      updateCountDownStatus(true);
    } else {
      ShowToast.warning(AppTranslation.text("something_went_wrong"));
    }
  };

  const alertMessageResponse = (msg: string) => {
    if (UtilityHelper.isNotEmpty(msg)) {
      AlertMesage({
        title: msg,
        onClick: () => {
          SettingsAccountVerificationProvider.navigate(
            appRoutes.routeNameSettingsPeronalInfo
          );
        },
      });
    }
  };

  useEffect(() => {
    checkVericationSession();
  }, []);

  return (
    <SettingsAccountVerificationContext.Provider
      value={{
        sendPin,
        resendVerification,
        updateCountDownStatus,
        pincodeLength,
        pincode,
        countDownStatus,
      }}
    >
      {children}
    </SettingsAccountVerificationContext.Provider>
  );
};

// IMPORT / USE CONTEXT ///////////////////////////////////////////////////////////////////
export const SettingsAccountVerificationContextImport = () => {
  const context = useContext(SettingsAccountVerificationContext);
  if (!context) {
    throw new Error(
      "SettingsAccountVerificationContextImport must be used within a SettingsAccountVerificationContextProvider"
    );
  }
  return context;
};
